import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20abstract%20geometric%20background%20with%20soft%20golden%20and%20cream%20gradients%2C%20gentle%20flowing%20lines%2C%20clean%20modern%20aesthetic%2C%20subtle%20texture%2C%20warm%20illumination%2C%20artistic%20composition%2C%20no%20text%2C%20peaceful%20atmosphere&width=1800&height=900&seq=hero-bg-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/60 via-foreground-950/40 to-foreground-950/70" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto py-20 md:py-28 lg:py-32 text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-accent-500/20 border border-accent-400/30 mb-6">
            <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse" />
            <span className="text-sm text-accent-200 font-medium">2026年8月地址已更新</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-background-50 mb-6 leading-tight">
            草榴回家的路
            <span className="block text-xl md:text-2xl lg:text-3xl font-body font-light text-background-300 mt-3">
              官方导航与最新地址入口
            </span>
          </h1>

          <p className="text-base md:text-lg text-background-300 max-w-2xl mx-auto mb-10 leading-relaxed">
            草榴回家的路是众多用户寻找草榴社区最新可用地址的核心指引。
            整合导航资源、备用域名入口、访问教程及常见问题解答，
            帮助每一位用户快速找到<strong className="text-background-100">回家的路</strong>。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/zuixin-dizhi"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 rounded-lg text-sm font-medium hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-link text-lg" />
              查看最新地址
            </Link>
            <Link
              to="/category/fangwen-jiaocheng"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-background-50/15 backdrop-blur-sm text-background-100 border border-background-300/30 rounded-lg text-sm font-medium hover:bg-background-50/25 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-guide-line text-lg" />
              访问教程
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}